/* eslint-disable @typescript-eslint/no-explicit-any */
import Loader from '@mercadoni/sinister/dist/cjs/mystiqueLoader'

import { notFound } from 'next/navigation'
import CategoryDisplay from './components/CategoryDisplay'

const CategoryLayout = ({
  loading,
  error,
  category,
  productsLength,
  categoryBanners,
  promoted = {},
  clientModel,
  onRouterChange,
  carousels,
  isMobile,
}: any) => {
  if (loading) {
    return <Loader />
  }

  if (error) {
    return notFound()
  }

  const placementBeacons = promoted?.isPromoted
    ? {
        'data-criteo-placement-onloadbeacon': promoted.onLoadBeacon,
        'data-criteo-placement-onviewbeacon': promoted.onViewBeacon,
      }
    : {}

  return (
    <CategoryDisplay
      placementBeacons={placementBeacons}
      currentCategory={category}
      categoryBanners={categoryBanners}
      path={category?.categoryNamesPath || ''}
      subCategories={category?.subCategories ?? []}
      productsLength={productsLength}
      clientModel={clientModel}
      onRouterChange={onRouterChange}
      carousels={carousels}
      isMobile={isMobile}
    />
  )
}

export default CategoryLayout
